import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-inner">
          <div className="footer-brand">
            <div className="nav-brand">
              <div className="nav-brand-mark">GA</div>
              <span>Gabriel Alabi</span>
            </div>
            <p className="footer-tagline">
              Backend / Fullstack engineer · Buenos Aires, Argentina
            </p>
            <p style={{ fontSize: '12px', color: 'var(--text-faint)', margin: 0 }}>
              &copy; {year} Gabriel Alabi
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-col">
              <div className="footer-col-title">Work</div>
              <a href="#products">Products</a>
              <a href="#case-studies">Case studies</a>
              <a href="#enterprise">Enterprise</a>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Connect</div>
              <a href="mailto:ivangabrielalabi@gmail.com">Email</a>
              <a href="https://github.com/RGabrielR" target="_blank" rel="noopener noreferrer">GitHub</a>
              <a href="https://www.linkedin.com/in/gabriel-alabi/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Resources</div>
              <a href="/CV-Gabriel-Alabi.pdf" target="_blank" rel="noopener noreferrer">Resume</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
